import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { commonInsertParameters } from "@repo/shared-utils/insert-params";
import { cvInsert, offerAPI, deleteFromCartApi } from "@repo/connection-manager";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { getApplicationIdAndProdCode, getApplicationId } from "./utils";
import { PDP_DETAILS, WHEELS_OFFER } from "../../../api-client/src/constants/util";

type CvModule = "ncv" | "lcv" | "cvbt" | "ucv";
type CvProdCode = "CRL" | "CRL_LCV" | "CRL_BT" | "CRUL";

const PRODUCT_CONFIG: Record<
  CvModule,
  {
    journeyName: string;
    prodCode: CvProdCode;
    appModule: string;
  }
> = {
  ncv: {
    journeyName: "CRL_New",
    prodCode: "CRL",
    appModule: "NCV",
  },
  lcv: {
    journeyName: "CRL_LCV",
    prodCode: "CRL_LCV",
    appModule: "LACV",
  },
  cvbt: {
    journeyName: "CRL_BT",
    prodCode: "CRL_BT",
    appModule: "CVLBT",
  },
  ucv: {
    journeyName: "CRL_Used",
    prodCode: "CRUL",
    appModule: "UCV",
  },
};

const INSERT_OPTIONS: Parameters<typeof commonInsertParameters>[0] = {
  appVersion: "v1",
  pwaVersion: "5.1.9",
};

const API_VERSION = "P.11.1.4";

export const cvHandler: SSORedirectHandler = async (data) => {
  const { mobileNo, custId, custType } = await getSessionData();
  const module = data.mapping.ssoModule as CvModule;
  const config = PRODUCT_CONFIG[module];

  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, [config.prodCode]);
  let response = undefined;
  const resume = applicationID !== undefined;

  const appId = await getApplicationId([config.prodCode]);
  if (appId) {
    await deleteFromCartApi({ appId, mobileNo, channel: "3in1" });
  }
  const [offer] = (await offerAPI(config.prodCode)) ?? [];
  response = await cvInsert({
    ...commonInsertParameters(INSERT_OPTIONS),
    mobileNo,
    custId,
    custType,
    journeyName: config.journeyName,
    prodName: config.prodCode,
    eventCode: WHEELS_OFFER,
    eventName: PDP_DETAILS,
    offerId: offer?.offerId ?? null,
    offerName: offer?.offerName ?? "",
    offerAmt: offer?.icorsAmount ?? "",
    apiVersion: API_VERSION,
    ...data.data?.cvInsert,
  });

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  redirectToWebform(
    callbackUrl.toString(),
    {
      ...response,
      applicationID: response?.id ?? applicationID,
      prodCode: response?.id ? "" : prodCode,
      product: config.prodCode,
      custType,
      resume: false,
      journeyName: config.journeyName,
    },
    `dynamicinapplink/COMMERCIAL_VEHICLE/${config.appModule}/${resume ? "resume" : "new"}`
  );
};
